///styling
import "./mediaInfo.scss";

interface MediaInfoProps {
    name: string;
    linkUrl?: string;
    linkText?: string;
}

function MediaInfo({name, linkUrl, linkText}: MediaInfoProps) {
 return (
    <div className="mediainfo">
        <h3 className="mediainfo__field">
            {linkUrl && !linkText ? (
                <a href={linkUrl} target="_blank" rel="noopener noreferrer">{name}</a>
            ) : (
                <>
                    {name}
                    {linkText && linkUrl && (
                        <> <a href={linkUrl} target="_blank" rel="noopener noreferrer">{linkText}</a></>
                    )}
                </>
            )}
        </h3>
    </div>
 )
}

export default MediaInfo;